export default __webpack_public_path__ + "static/media/different.8fc3178f.jpg";